/**
 * Simula fila de jobs após salvar frequência: pending → success (App faz poll a cada 2s).
 * Reutiliza o mesmo ciclo de fases que notas V2; um job demo por vez.
 */

import { registerDemoJob } from "./demoJobHistory";

let phase = "idle";
let lastJob = null;

export function notifyDemoFrequencyJobPosted(body) {
  if (!body) {
    return;
  }
  const { filter, classId } = body;
  const course = (filter && filter.course) || {};
  phase = "pending";
  lastJob = {
    id: "demo-frequency-job",
    status: "pending",
    name: "save_frequency",
    title: `Turma ${classId} | Frequência`,
    classId,
    course: course.id,
    period: "Frequência",
    payload: body
  };
  registerDemoJob(lastJob);
}

export function takeDemoFrequencyJobsResponse() {
  if (phase === "idle" || !lastJob) {
    return [];
  }
  if (phase === "pending") {
    phase = "await_success";
    registerDemoJob({ ...lastJob, status: "pending" });
    return [
      {
        ...lastJob,
        status: "pending"
      }
    ];
  }
  if (phase === "await_success") {
    const done = { ...lastJob, status: "success" };
    registerDemoJob(done);
    phase = "idle";
    lastJob = null;
    return [done];
  }
  return [];
}
